import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { PILLARS } from 'assets/database/onboarding'
import { PillarButton } from 'components/common/PillarButton'
import { activateOnboardingStep, setOnboardingAnswers } from 'actions/assessment'
import './style.scss'

const Pillars = () => {
    const dispatch = useDispatch()

    const [pillar, setPillar] = useState('')
    const {
        appState: {
            onboardingAnswers: { assessment, pillarSelected },
        },
    } = useSelector(state => state.assessment)

    useEffect(() => {
        if (pillarSelected) {
            setPillar(pillarSelected)
        } else {
            let pillars = Object.keys(assessment[0]).slice(0, 6)
            let values = Object.values(assessment[0])
                .slice(0, 6)
                .map(el => el.value)
            let index = values.findIndex(val => Math.min(...values) === val)
            if (index !== -1) {
                setPillar(pillars[index])
                dispatch(setOnboardingAnswers(pillars[index], 'pillarSelected'))
                dispatch(activateOnboardingStep({ number: 5, state: false }))
            }
        }
    }, [assessment, pillarSelected])

    useEffect(() => {
        if (pillar) {
            dispatch(activateOnboardingStep({ number: 5, state: false }))
            dispatch(setOnboardingAnswers(pillar, 'pillarSelected'))
        }
    }, [pillar, setPillar])

    useEffect(() => {
        if (pillarSelected !== pillar) {
            dispatch(activateOnboardingStep({ number: 6, state: true }))
        }
    }, [pillar, pillarSelected])

    const handlePillar = answer => {
        setPillar(answer.text)
    }
    return (
        <div className="pillarList">
            {PILLARS.map(pillar => (
                <PillarButton key={pillar.id} answer={pillar} onSelect={handlePillar} pillarSelected={pillarSelected} />
            ))}
        </div>
    )
}

export default Pillars
